"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ruleCart;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _sortBy3 = _interopRequireDefault(require("lodash/fp/sortBy"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _pipeP = _interopRequireDefault(require("../utils/pipeP"));

var _reduceError = _interopRequireDefault(require("../utils/reduceError"));

var _ruleApplicable = _interopRequireDefault(require("../utils/ruleApplicable"));

var _markApplicable = _interopRequireDefault(require("../utils/markApplicable"));

var _makeMap = _interopRequireDefault(require("../utils/makeMap"));

var _calcValueAdded = _interopRequireDefault(require("../utils/calcValueAdded"));

var _arrayMergeUnique = _interopRequireDefault(require("../utils/arrayMergeUnique"));

var applyRuleOnCart = function applyRuleOnCart(ctx, cart) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(rule) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _pipeP.default)((0, _ruleApplicable.default)(ctx, rule), (0, _markApplicable.default)(ctx, rule), (0, _makeMap.default)(ctx, rule), (0, _calcValueAdded.default)(ctx, rule))(cart));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var applyAllRulesOnCart = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(ctx, rules, cart) {
    var _ref3, _ref4, errs, toFindWinnerIn, err, _sortBy, _sortBy2, winner, rest, winnerMarked, cartPartial, ruleFootprint, restCartPartial, rCartPartial, nextCart, applicableRules, log;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = function (_ref5) {
              var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
                  es = _ref6[0],
                  y = _ref6[1];

              return [es, y.filter(Boolean)];
            };

            _context2.next = 3;
            return Promise.all(rules.map(applyRuleOnCart(ctx, cart)));

          case 3:
            _context2.t1 = _context2.sent.reduce(function (r, _ref7) {
              var _ref8 = (0, _slicedToArray2.default)(_ref7, 2),
                  err = _ref8[0],
                  resultCtx = _ref8[1];

              return [[].concat((0, _toConsumableArray2.default)(r[0]), [err]), [].concat((0, _toConsumableArray2.default)(r[1]), [resultCtx])];
            }, [[], []]);
            _ref3 = (0, _context2.t0)(_context2.t1);
            _ref4 = (0, _slicedToArray2.default)(_ref3, 2);
            errs = _ref4[0];
            toFindWinnerIn = _ref4[1];
            err = (0, _reduceError.default)(errs);

            if (!err) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", [err]);

          case 11:
            if (toFindWinnerIn.length) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", [null, cart, {}]);

          case 13:
            // najdi vitaza a v logu ho oznac
            _sortBy = (0, _sortBy3.default)([function (wc) {
              return wc.valueAdded;
            }], toFindWinnerIn), _sortBy2 = (0, _toArray2.default)(_sortBy), winner = _sortBy2[0], rest = _sortBy2.slice(1);
            winnerMarked = (0, _extends2.default)({}, winner, {
              winner: true
            }); // zmutuj kosik

            cartPartial = winnerMarked.partial;
            ruleFootprint = cartPartial.ruleFootprint, restCartPartial = (0, _objectWithoutProperties2.default)(cartPartial, ["ruleFootprint"]);
            rCartPartial = (0, _extends2.default)({}, restCartPartial, ruleFootprint ? {
              ruleFootprint: [ruleFootprint]
            } : {});
            nextCart = (0, _deepmerge.default)(cart, rCartPartial, {
              arrayMerge: _arrayMergeUnique.default
            }); // do logu poznac aplikovane pravidla

            applicableRules = [winner].concat((0, _toConsumableArray2.default)(rest)).map(function (i) {
              return {
                rule: i.applicableRule,
                valueAdded: i.valueAdded
              };
            });
            log = {
              groupType: 'cart',
              winner: winner,
              applicableRules: applicableRules,
              applicableRuleCodes: applicableRules.map(function (i) {
                return i.rule.ruleCode;
              }),
              applicableRuleThreads: applicableRules.map(function (i) {
                return i.rule.ruleThread;
              })
            };
            return _context2.abrupt("return", [null, nextCart, log]);

          case 22:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function applyAllRulesOnCart(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

function ruleCart(_x5, _x6) {
  return _ruleCart.apply(this, arguments);
}

function _ruleCart() {
  _ruleCart = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(ctx, rules) {
    var cart, _yield$applyAllRulesO, _yield$applyAllRulesO2, err, nextCart, log;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            cart = ctx.cart;
            _context3.next = 3;
            return applyAllRulesOnCart(ctx, rules, cart);

          case 3:
            _yield$applyAllRulesO = _context3.sent;
            _yield$applyAllRulesO2 = (0, _slicedToArray2.default)(_yield$applyAllRulesO, 3);
            err = _yield$applyAllRulesO2[0];
            nextCart = _yield$applyAllRulesO2[1];
            log = _yield$applyAllRulesO2[2];
            return _context3.abrupt("return", [(0, _reduceError.default)(err), (0, _extends2.default)({}, ctx, {
              cart: nextCart
            }), log]);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _ruleCart.apply(this, arguments);
}